import { toAbsoluteUrl } from "../../utils/AssetHelpers";

const BillExampleModal = () => {
  return (
    <>
      <div>
        <img
          src={toAbsoluteUrl("/images/ext/extBill.jpg")}
          style={{ width: "100%", border: "1px solid" }}
          alt="Example of a utility bill"
        />
      </div>
    </>
  );
};

export { BillExampleModal };
